import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Row } from 'react-bootstrap';
import { Card, CardContent, Table, TableBody, Typography, Theme } from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';

import { IProduct } from '../../../../../interfaces/product';
import { IUser } from '../../../../../interfaces/user';
import homeStyles from '../../../homeStyles';
import { useDefineUserRole } from '../../../../../hooks';
import ProductTableItem from './ProductTableItem';

interface IProductsProps {
  data: IProduct[];
  isAuthorized: boolean;
  me: IUser | undefined;
  companyId?: number;
}
const ProductsTableListComponent: React.FC<IProductsProps> = ({
  data,
  isAuthorized,
  me,
  companyId,
}) => {
  const intl = useIntl();
  const classes = useStyles();
  const homeClasses = homeStyles();
  const isVendor = useDefineUserRole(me, ['ROLE_VENDOR', 'ROLE_VENDOR_STAFF']);

  return (
    <Row>
      <Col>
        {!data || !data.length ? (
          <Typography className={classes.empty} component='h5' variant='h5'>
            {intl.formatMessage({ id: 'COMMON.LIST.EMPTY' })}
          </Typography>
        ) : (
          <>
            <Card className={classes.card}>
              <CardContent
                className={homeClasses.classes.tableContainer}
                style={{ paddingLeft: 10 }}
              >
                <Table aria-label='simple table'>
                  <TableBody>
                    {data.map(item => (
                      <React.Fragment key={item.id}>
                        <ProductTableItem
                          isAuthorized={isAuthorized}
                          me={me}
                          product={item}
                          prices={
                            isVendor || me?.is_admin
                              ? item.prices_values?.find(i => i.vendor?.id === companyId)
                                  ?.prices
                              : undefined
                          }
                        />

                        <div style={{ marginBottom: 16 }} />
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          </>
        )}
      </Col>
    </Row>
  );
};

const useStyles: any = makeStyles((theme: Theme) =>
  createStyles({
    empty: {
      marginBottom: 20,
    },
    buttons: {
      marginRight: theme.spacing(3),
    },
    card: {
      marginBottom: theme.spacing(3),
      boxShadow: 'none !important',
      backgroundColor: 'transparent !important',
    },
    categoryTree: {
      maxWidth: 400,
    },
    actions: {
      marginTop: theme.spacing(2),
    },
    img: {
      // maxHeight: 55,
      width: 100,
      height: 100,
    },
    productNameContainer: {
      display: 'flex',
      flexDirection: 'column',
      textDecoration: 'none',
    },
    productName: {
      fontSize: 18,
      fontWeight: 'bold',
      color: '#0d0a05',
    },
    productCompany: {
      fontSize: 14,
      fontWeight: 'normal',
      color: '#7c97c0',
      backgroundColor: '#fff3df',
      padding: '5px 10px',
      textDecoration: 'none',
      borderRadius: 4,
    },
    autoLoc: {
      maxWidth: 400,
    },
    cell: {
      fontWeight: 'bold',
    },
    row: {
      backgroundColor: '#fff',
      borderRadius: 16,
      padding: 0,
    },
    firstColumnItem: {
      backgroundColor: '#fff',
      borderRadius: '16px 0 0 16px',
      borderBottom: 'none !important',
      marginBottom: '16px !important',
      padding: 0,
    },
    columnItem: {
      backgroundColor: '#fff',
      borderBottom: 'none !important',
      marginBottom: '16px !important',
      padding: 0,
    },
    lastColumnItem: {
      backgroundColor: '#fff',
      borderRadius: '0 16px 16px 0',
      borderBottom: 'none !important',
      marginBottom: '16px !important',
      padding: 0,
    },
  })
);

export default ProductsTableListComponent;
